'use client';

import { GoogleAdProps } from "@/app/utilities/interfaces";
import Image from "next/image";
import React from "react";
import { customImageLoader } from "@/lib/utils/customLoader";

const GoogleAd: React.FC<GoogleAdProps> = ({
  image,
  link,
  alt = "Ad",
  className = "",
  width = 1200,
  height = 250,
  priority = false,
}) => {
  const isNumericWidth = typeof width === "number";
  const isNumericHeight = typeof height === "number";

  const style = {
    width: isNumericWidth ? `${width}px` : width,
    height: isNumericHeight ? `${height}px` : height,
  };

  return (
    <div className="relative">

      {/* Hidden image that loads in background */}
        <div
          className={`relative overflow-hidden ${className}`}
          style={style}
        >
          <a
            href={link || "#"}
            target="_blank"
            title="google ad banner"
            rel="noopener noreferrer"
            className="block w-full h-full"
          >
            <Image
              src={image}
              alt={alt}
              title={alt}
              fill
              className="object-cover rounded-[12px]"
              sizes="(max-width: 768px) 100vw, 800px"
              quality={75}
              loading={priority ? "eager" : "lazy"}
              priority={priority}
              fetchPriority={priority ? "high": "auto"}
              loader={customImageLoader}
            />
          </a>
        </div>
    </div>
  );
};

export default GoogleAd;
